module.exports = __webpack_public_path__ + "img/T948.a3d221a6.jpg";